import React from "react";
import "./styles.scss";
import coachingData from "../../../assets/data/coaching";

import FormationCell from "../../../components/FormationCell";
import EvaluateCard from "../../../components/EvaluateCard";

type CoachingSectionProps = {
  openFinancementsModal: any;
};

const CoachingSection: React.FC<CoachingSectionProps> = ({
  openFinancementsModal
}) => {
  return (
    <section className="coaching-section" id="coaching">
      <h2>Coaching</h2>
      <p>
        Le coaching professionnel est un processus interactif et individualisé
        au cours duquel un coach qualifié guide et soutient une personne (le
        coaché) dans le développement de ses compétences, la réalisation de ses
        objectifs professionnels et la maximisation de son potentiel, en
        utilisant des techniques de questionnement, de réflexion et de
        planification.
      </p>
      <br />
      <EvaluateCard
        titles={[
          "Se sentir légitime, savoir dire non, prendre la parole avec impact… Ce n’est pas toujours inné.",
          "Ce mini-questionnaire vous permet de savoir si un accompagnement en coaching peut vous aider à adopter la posture juste et à gagner en confiance. Répondez en toute simplicité !"
        ]}
        questions={[
          "Vous arrive-t-il de manquer d’assurance dans vos décisions ou prises de parole ?",
          "Vous avez du mal à dire « non » ou à poser des limites claires ?",
          "Vous ressentez du stress à l’idée d’affirmer vos besoins ou vos idées ?",
          "Vous souhaitez mieux gérer vos émotions dans des situations difficiles ?",
          "Vous voulez adopter une posture plus sereine et plus alignée avec vos valeurs ?",
          "Vous aimeriez être guidé(e) pour gagner en confiance et passer à l’action ?"
        ]}
        subtitle={
          "Vous pensez que c’est le moment de renforcer votre posture ? Contactez-moi pour un premier échange gratuit et personnalisé !"
        }
      />
      <div className="formation-cells-container">
        {coachingData.map((coaching, index) => (
          <FormationCell
            key={index}
            image={coaching.image}
            title={coaching.title}
            description={coaching.description}
            id={coaching.id}
            type={coaching.type}
            onOpenFinancementsModal={() => openFinancementsModal(coaching.type)}
          />
        ))}
      </div>
      <p style={{ padding: "40px 0px 10px 0px" }}>
        <i>
          Cette formation n’ayant pas encore fait l’objet d’une session sur la
          période de référence, les indicateurs de résultats ne sont pas encore
          disponibles. Ils seront publiés à l’issue des premières sessions.
        </i>
      </p>
    </section>
  );
};

export default CoachingSection;
